// src/lib/rewardedVideo.ts

const BOOST_KEY = 'sbarazzo_video_boost';

export interface VideoBoost {
  adFreeGames: number;
}

export function isAdsPaused(): boolean {
  return import.meta.env.VITE_ADS_PAUSED === 'true';
}

export function isBoostActive(): boolean {
  const raw = localStorage.getItem(BOOST_KEY);
  if (!raw) return false;
  try {
    const boost: VideoBoost = JSON.parse(raw);
    return boost.adFreeGames > 0;
  } catch {
    return false;
  }
}

export function activateBoost(): void {
  const raw = localStorage.getItem(BOOST_KEY);
  let currentGames = 0;
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      currentGames = parsed.adFreeGames || 0;
    } catch {}
  }
  const boost: VideoBoost = {
    adFreeGames: currentGames + 1,
  };
  localStorage.setItem(BOOST_KEY, JSON.stringify(boost));
  // Notify App to re-render
  window.dispatchEvent(new Event('video_boost_updated'));
}

export function decrementBoost(): void {
  const raw = localStorage.getItem(BOOST_KEY);
  if (!raw) return;
  try {
    const boost: VideoBoost = JSON.parse(raw);
    if (boost.adFreeGames > 0) {
      boost.adFreeGames -= 1;
      localStorage.setItem(BOOST_KEY, JSON.stringify(boost));
      window.dispatchEvent(new Event('video_boost_updated'));
    }
  } catch {
    localStorage.removeItem(BOOST_KEY);
  }
}

export function clearBoost(): void {
  localStorage.removeItem(BOOST_KEY);
  window.dispatchEvent(new Event('video_boost_updated'));
}

// Boost system — video reward integration

// Called by App.tsx at session start to check if boost is still valid
export function syncBoostState(): void {
  const raw = localStorage.getItem(BOOST_KEY);
  if (!raw) return;
  try {
    const boost: VideoBoost = JSON.parse(raw);
    if (boost.adFreeGames <= 0) {
      clearBoost();
    }
  } catch {
    localStorage.removeItem(BOOST_KEY);
  }
}
